export default __webpack_public_path__ + "static/media/home-decor-img-03.47fa08a0.png";